import { Pipe, PipeTransform } from '@angular/core';

/**
 * Compact relative time — "just now", "3m", "5h", "2d", then a short date.
 * Accepts an ISO string, epoch millis, or Date. Empty / invalid → "—".
 */
@Pipe({ name: 'timeAgo', standalone: true })
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '—';
    }
    const then = new Date(value).getTime();
    if (Number.isNaN(then)) {
      return '—';
    }
    const secs = Math.round((Date.now() - then) / 1000);
    if (secs < 45) {
      return 'just now';
    }
    if (secs < 3600) {
      return `${Math.round(secs / 60)}m`;
    }
    if (secs < 86400) {
      return `${Math.round(secs / 3600)}h`;
    }
    if (secs < 7 * 86400) {
      return `${Math.round(secs / 86400)}d`;
    }
    return new Date(value).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'short',
    });
  }
}
